import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const SparklesIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Sparkles Icon</title>;
    t1 = <path d="M6.69449 3.0482C6.98277 2.31726 8.01723 2.31727 8.30551 3.0482L9.19886 5.31332C9.28687 5.53648 9.46352 5.71313 9.68668 5.80114L11.9518 6.69449C12.6827 6.98277 12.6827 8.01723 11.9518 8.30551L9.68668 9.19886C9.46352 9.28687 9.28687 9.46352 9.19886 9.68668L8.30551 11.9518C8.01723 12.6827 6.98277 12.6827 6.69449 11.9518L5.80114 9.68668C5.71313 9.46352 5.53648 9.28687 5.31332 9.19886L3.0482 8.30551C2.31726 8.01723 2.31727 6.98277 3.0482 6.69449L5.31332 5.80114C5.53648 5.71313 5.71313 5.53648 5.80114 5.31332L6.69449 3.0482Z" stroke="currentColor" strokeWidth="1" />;
    t2 = <path d="M13.7391 11.1234C13.8916 10.7366 14.4391 10.7366 14.5916 11.1234L15.2588 12.8151C15.3054 12.9331 15.3989 13.0266 15.517 13.0732L17.2086 13.7404C17.5954 13.8929 17.5954 14.4404 17.2086 14.5929L15.517 15.2601C15.3989 15.3067 15.3054 15.4001 15.2588 15.5182L14.5916 17.2099C14.4391 17.5967 13.8916 17.5967 13.7391 17.2099L13.0719 15.5182C13.0253 15.4001 12.9319 15.3067 12.8138 15.2601L11.1221 14.5929C10.7353 14.4404 10.7353 13.8929 11.1221 13.7404L12.8138 13.0732C12.9319 13.0266 13.0253 12.9331 13.0719 12.8151L13.7391 11.1234Z" stroke="currentColor" strokeWidth="1" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" aria-label="Sparkles Icon" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};